// extracted by mini-css-extract-plugin
export var body = "SectionTextOnlySignpostCard-module--body--7eca0";
export var container = "SectionTextOnlySignpostCard-module--container--ea780";
export var containerstacked = "SectionTextOnlySignpostCard-module--containerstacked--00172";
export var footertext = "SectionTextOnlySignpostCard-module--footertext--11459";
export var sectiontextonlysignpostcard = "SectionTextOnlySignpostCard-module--sectiontextonlysignpostcard--dee21";
export var title = "SectionTextOnlySignpostCard-module--title--1f593 headings-module--sectionHeading--a8f67";
export var titlewrapper = "SectionTextOnlySignpostCard-module--titlewrapper--64d67";